import { Col, Container, Row } from "react-bootstrap"
import '../Css/Contact.css';
import { useEffect, useState } from "react";
import Loader from "../component/Loader";
import { FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";
import aman from '../image/New Stud Dash/aman.webp';
function importAll(r) {
    let images = {};
    r.keys().forEach((item, index) => {
        images[index] = { src: r(item), name: item.replace("./", "") };
    });
    return images;
}
const images = importAll(require.context("../image/image/Industries Expert", false, /\.(webp)$/))
function Mentor() {
    const [loading, setLoading] = useState(true);
    const [imageUrls, setImageUrls] = useState([]);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(() => {
        setImageUrls(Object.values(images));
        // Wait for images to be available, then set loading false
        if (Object.values(images).length > 0) {
            setLoading(false);
        }
    }, []);
    const openLightbox = (index) => {
        setCurrentIndex(index);
        setLightboxOpen(true);
    };

    const prevImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? imageUrls.length - 1 : prevIndex - 1));
    };

    const nextImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex === imageUrls.length - 1 ? 0 : prevIndex + 1));
    };

    return (
        <>
            {loading && <Loader showimg={loading} />}
            {/* mentor */}
            <Container fluid style={{ background: '#1E2538' }} className="hero_all overflow-hidden">
                <Row className="justify-content-center">
                    <Col xl="12">
                        <div class="header_banner align-self-center  text-center pt-0">
                            <br />
                            <div className="main_part positions-relative">
                                <div className="fs-3  head_text text-white">Mentor</div>
                                <h1 class="fw-bold h1_title">CS Advisor Team</h1>
                            </div>
                            <br />
                        </div>
                    </Col>
                </Row>
            </Container>
            {/* mentor second sec image */}
            <Container fluid>
                <Row className="justify-content-center  p-0 pt-5 pb-3 mt-5">
                    <Col md="11" xxl="9">
                        <Row className="g-4 justify-content-center">
                            {imageUrls?.map((image, index) => {
                                console.log(imageUrls);

                                return (
                                    <Col xs="10" sm="6" md="4" xl="3" key={index}>
                                        <div onClick={() => openLightbox(index)}>
                                            <img
                                                className="rounded-3 pointer mentor_image"
                                                key={index}
                                                src={image?.src}
                                                alt={`Industries Expert ${index + 1}`}
                                                onError={(e) => console.log("Image failed to load:", e.target.src)}
                                            />
                                        </div>
                                    </Col>
                                );
                            })}

                        </Row>
                    </Col>
                </Row>
            </Container>
            {/* <!-- lightboxer with Slider --> */}
            {lightboxOpen && (
                <div className="lightboxer" onClick={(e) => {
                    if (e.target.classList.contains("lightboxer")) {
                        setLightboxOpen(false);
                    }
                }}>
                    <span className="close-lightboxer" onClick={() => setLightboxOpen(false)}>×</span>
                    <img src={imageUrls[currentIndex].src} alt={imageUrls[currentIndex].name} />
                    <button className="prev" onClick={(e) => { e.stopPropagation(); prevImage(); }}>❮</button>
                    <button className="next" onClick={(e) => { e.stopPropagation(); nextImage(); }}>❯</button>
                </div>
            )}
            {/* contact */}
            <div className="counseller_contact mt-5 pt-sm-5">
                <Container fluid style={{ background: "#1E2538"}}>
                    <Row className="justify-content-center">
                        <Col lg="11" xl="10" xxl="7" className="py-5">
                            <div className="py-sm-5 py-3 justify-content-center  d-flex flex-md-nowrap flex-wrap align-items-center justify-content-sm-between">
                                <div className="d-flex flex-sm-nowrap justify-content-center text-center text-sm-start flex-wrap">
                                    <div className="text-center justify-content-center  col-sm col-12">
                                        <img src={aman} alt="meena" className="align-self-center counsellor_image rounded-circle" />
                                    </div>
                                    <div className="text-white ps-sm-5">
                                        <div className="fs-4 fw-bold counseling_title">Aman Ajudiya</div>
                                        <div className="fs-4 counseling_desc py-sm-2">Director, School Partnerships Programs</div>
                                        <div className="fs-4  pointer"><Link className="counseling_desc text-white" to={"tel:+91-96620-87470"}>+91-96620-87470</Link></div>
                                        <div className="py-sm-2 fs-4"><Link to="mailto:aman.ajudiya@careersahi.com" className="text-decoration-none counseling_desc pointer text-white">
                                            aman.ajudiya@careersahi.com
                                        </Link></div>
                                    </div>
                                </div>
                                <div className="text-center mt-sm-0 mt-2 ms-md-0 ms-sm-auto me-sm-3">
                                    <div className="fs-4 text-white fw-bold">Contact Us</div>
                                    <Link target="_blank" to="https://api.whatsapp.com/send/?phone=9662087470&text=Hello CareerSahi&type=phone_number&app_absent=0">
                                        <button  className="px-md-4 px-3 mt-sm-3 fs-5 mt-1 d-flex align-items-center rounded-1 whats_button  border-0 py-2 text-white">
                                            <FaWhatsapp className="fs-5 mt-1 align-self-center me-2 " />
                                            Chat on WhatsApp
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </Col>
                        <button style={{ height: "18px" }} className="bg-white col-12 mb-2 border-0"></button>
                    </Row>
                </Container>
            </div>
        </>
    )
}
export default Mentor